"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _View = require("../../components/view/View");

var _View2 = _interopRequireDefault(_View);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TableBody = require("./TableBody");

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableFooter = require("../../components/table/TableFooter");

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _TableHeader = require("../../components/table/TableHeader");

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableFilter = require("../../components/table/TableFilter");

var _TableFilter2 = _interopRequireDefault(_TableFilter);

require("../../assets/css/components/table/table.css");

var _Card = require("../card/Card");

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_React$Component) {
    _inherits(Table, _React$Component);

    function Table(props) {
        _classCallCheck(this, Table);

        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

        _this.onPageChange = function (page) {
            var path = _this.state.dataPath || '';
            var caracter = path.substring(path.length, path.length - 1) === "&" ? '' : '?';

            if (_this.props.collection) {
                _this.setState({ page: 0 });
                _this.props.onPaginator(page);
            } else {
                var url = path + caracter + 'page=' + page + '&size=' + _this.state.size;
                _this.setUrlPageSize(url, page, null);
            }
        };

        _this.onSort = function (sort) {
            var url = _this.state.dataPath + '?page=0&size=' + _this.state.size;

            sort.forEach(function (e, i) {
                url += sort[i].direction !== '' ? '&sort=' + sort[i].property + ',' + sort[i].direction.toLowerCase() : '';
            });

            _this.setUrlPageSize(url, null, null);
        };

        _this.onLimitChange = function (event, data) {
            if (_this.props.collection) {
                _this.props.onLimitChange(Number(data.value));
            } else {
                var url = _this.state.dataPath + '?page=0&size=' + data.value;
                _this.setUrlPageSize(url, null, data.value);
            }
        };

        _this.setUrlPageSize = function (url, page, size) {
            _this.setState({ path: url || _this.state.url, page: page || _this.state.page, size: size || _this.state.size });
            _this.props.onPaginator(url);
        };

        _this.getDataMapped = function (dataMapper) {
            return _this.props.collection ? _this.props.data.map(dataMapper) : _this.props.data.content.map(dataMapper);
        };

        _this.noContentMessage = function (noContentMessage) {
            if (_this.props.card) return _react2.default.createElement(
                _Card2.default,
                { titulo: _this.props.title, borderBottom: true, hiddenDescription: true, descricao: _this.props.summary, tools: _this.props.tools, displayLoading: _this.props.displayLoading, loadingPosition: "top" },
                _react2.default.createElement(
                    "div",
                    { className: "empty-text" },
                    noContentMessage
                )
            );else return _react2.default.createElement(
                "div",
                { className: "empty-text" },
                noContentMessage
            );
        };

        _this.getTableFooter = function (numberOfElements, paginator) {
            return _react2.default.createElement(_TableFooter2.default, { numberOfElements: numberOfElements, onChange: _this.onLimitChange.bind(_this),
                onPageChange: _this.onPageChange, paginable: paginator, collection: _this.props.collection,
                page: _this.props.page, qtElements: _this.props.qtElements,
                totalElements: _this.props.totalElements });
        };

        _this.getTableBody = function (dataMapper) {
            return _react2.default.createElement(_TableBody2.default, { data: _this.getDataMapped(dataMapper) });
        };

        _this.getTableHeader = function (dataMapper) {
            return _react2.default.createElement(_TableHeader2.default, { data: _this.getDataMapped(dataMapper), onSort: _this.onSort, sorted: _this.props.data.sort });
        };

        _this.getTable = function (summary, dataMapper) {
            if (_this.props.card) return _react2.default.createElement(
                _Card2.default,
                { titulo: _this.props.title, noPadding: true, borderBottom: true, hiddenDescription: true, descricao: summary, tools: _this.props.tools, displayLoading: _this.props.displayLoading, loadingPosition: "top" },
                _react2.default.createElement(_TableFilter2.default, {
                    dataMapper: _this.props.dataMapper,
                    getDataMapped: _this.getDataMapped,
                    onFilter: _this.props.onFilter }),
                _react2.default.createElement(
                    "div",
                    { className: "flat-table-div" },
                    _react2.default.createElement(
                        "table",
                        { summary: summary, tabIndex: 0,
                            className: 'flat-table ' + (_this.props.striped ? 'table-striped' : '') },
                        _this.getTableHeader(dataMapper),
                        _this.getTableBody(dataMapper)
                    )
                ),
                _this.getTableFooter(_this.props.data.numberOfElements, _this.props.data)
            );else return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_TableFilter2.default, {
                    dataMapper: _this.props.dataMapper,
                    getDataMapped: _this.getDataMapped,
                    onFilter: _this.props.onFilter }),
                _react2.default.createElement(
                    "div",
                    { className: "flat-table-div" },
                    _react2.default.createElement(
                        "table",
                        { summary: summary, tabIndex: 0,
                            className: 'flat-table ' + (_this.props.striped ? 'table-striped' : '') },
                        _this.getTableHeader(dataMapper),
                        _this.getTableBody(dataMapper)
                    )
                ),
                _this.getTableFooter(_this.props.data.numberOfElements, _this.props.data)
            );
        };

        _this.state = {
            sort: [],
            dataPath: _this.props.url,
            path: _this.props.url,
            size: 10,
            page: 0
        };
        return _this;
    }

    _createClass(Table, [{
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState) {
            return nextProps.page !== this.state.page && this.props.scrollTop ? window.scrollTo(0, 0) : null;
        }
    }, {
        key: "getContent",
        value: function getContent() {
            return this.props.data !== null && (this.props.collection ? this.props.data.length > 0 : this.props.data.content.length > 0) ? this.getTable(this.props.summary, this.props.dataMapper) : this.noContentMessage(this.props.noContentMessage || "Nenhum dado para ser exibido");
        }
    }, {
        key: "render",
        value: function render() {
            return this.getContent();
        }
    }]);

    return Table;
}(_react2.default.Component);

exports.default = Table;


Table.propTypes = {
    striped: _propTypes2.default.bool,
    summary: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    dataMapper: _propTypes2.default.func.isRequired,
    onPaginator: _propTypes2.default.func.isRequired,
    collection: _propTypes2.default.bool,
    page: _propTypes2.default.number,
    qtElements: _propTypes2.default.number
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/table/Table.js
// module id = 1143
// module chunks = 0